import React, { useMemo } from "react";
import { useSelector, shallowEqual } from "react-redux";
import objectPath from "object-path";

import { useHtmlClassService } from "../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../_helpers";
import { getDatabaseNamePath, roles } from "../../../../app/config/config";

export function Brand() {
  const uiService = useHtmlClassService();

  const user = useSelector((state) => state.auth.user, shallowEqual);
  const role = parseInt(user.idRole);

  const layoutProps = useMemo(() => {
    return {
      brandClasses: uiService.getClasses("brand", true),
      asideSelfMinimizeToggle: objectPath.get(uiService.config, "aside.self.minimize.toggle"),
      headerLogo: uiService.getLogo(),
      headerStickyLogo: uiService.getStickyLogo(),
      asideStyle: `brand-${getDatabaseNamePath()}`,
      // role === roles.agenteValderma
      //   ? "brand-valderma"
      //   : role === roles.agenteRoypet
      //     ? "brand-roypet"
      //     : role === roles.agenteRoydermal
      //       ? "brand-roydermal"
      //       : "brand-global",
      // logo: toAbsoluteUrl("/media/logos/logo-bianco.png"),
      // logo: toAbsoluteUrl(`/media/${getDatabaseNamePath()}/logos/logo-bianco.png`),
      logo: "/media/logos/logo-bianco.png",
      // role === roles.agenteValderma
      //     ? "/media/valderma/logos/logo-bianco.png"
      //     : role === roles.agenteRoypet
      //       ? "/media/roypet/logos/logo-bianco.png"
      //       : role === roles.agenteRoydermal
      //         ? "/media/roydermal/logos/logo-bianco.png"
      //         : "/media/roydermal/logos/global-logo-bianco.png",
      // role === roles.agenteValderma
      //   ? toAbsoluteUrl("/media/logos/valderma-logo-bianco.png")
      //   : role === roles.agenteRoypet
      //     ? toAbsoluteUrl("/media/logos/roypet-logo-bianco.png")
      //     : role === roles.agenteRoydermal
      //       ? toAbsoluteUrl("/media/logos/roydermal-logo-bianco.png")
      //       : toAbsoluteUrl("/media/logos/global-logo-bianco.png"),
      target: "https://" + getDatabaseNamePath() + ".it",
        // role === roles.agenteValderma
        //   ? "https://www.valderma.it"
        //   : role === roles.agenteRoypet
        //   ? "https://www.roypet.it/"
        //   : "https://roydermal.it/",
    };
    /*eslint-disable-next-line*/
  }, [uiService]);

  return (
    <>
      {/* begin::Brand */}
      <div
        className={`${layoutProps.asideStyle} brand_removed flex-column-auto ${layoutProps.brandClasses}`}
        id="kt_brand"
      >
        {/* begin::Logo */}

        <a href={layoutProps.target} target={"_blank"} className="brand-logo">
          <img alt="logo" style={{ maxWidth: "165px", width: "100%" }} src={toAbsoluteUrl(layoutProps.logo)} />
        </a>
        {/* end::Logo */}
      </div>
      {/* end::Brand */}
    </>
  );
}
